import { InfoM } from '@app/modules/audit/modules/aod/screens/aod-rule-view/components/InfoM';
import { Box, Chip, Grid } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { GroupWithUsers } from '../../../../../../core/types/users';
import { getAppUserDisplayName } from '../../../../../../helpers/user';

interface Props {
  readonly group: GroupWithUsers;
}

export function GroupInfo(p: Props) {
  const { $t } = useIntl();
  const { group } = p;
  const { users } = group;

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InfoM label={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}>
            {group.name}
          </InfoM>
        </Grid>
        <Grid item xs={12}>
          <InfoM
            label={
              <FormattedMessage
                id="admin.groups.viewScreen.assignedUsers.title"
                defaultMessage="Usuarios asignados"
              />
            }
          >
            <Box>
              <Box sx={{ mb: 2 }}>
                <FormattedMessage
                  id="admin.groups.viewScreen.assignedUsers.body"
                  defaultMessage="Este grupo {count, plural, =0 {no tiene} one {tiene #} other {tiene #} } {count, plural, one {usuario asignado} other {usuarios asignados} }"
                  values={{
                    count: users.length,
                  }}
                />
              </Box>
              {users.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {users.map((u) => (
                    <Chip
                      key={u.id}
                      label={getAppUserDisplayName(u)}
                      variant="outlined"
                      size="small"
                    />
                  ))}
                </Box>
              )}
            </Box>
          </InfoM>
        </Grid>
      </Grid>
    </Box>
  );
}
